<template>
  <div class="card p-3 shadow-sm">
    <div class="container-fluid my-4">
      <!-- Botón de regreso -->
      <button
        class="btn btn-outline-secondary btn-sm mb-3"
        @click="$router.push('/inicio')"
        type="button"
      >
        <i class="bi bi-arrow-left me-1"></i> Regresar
      </button>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="fw-semibold text-primary m-0">Reservas con pago pendiente</h4>
        <button
          class="btn btn-danger btn-sm"
          @click="descargarPDF"
          :disabled="reservas.length === 0"
          title="Descargar PDF"
        >
          <i class="bi bi-file-pdf me-1"></i> Descargar PDF
        </button>
      </div>

      <!-- Filtro por fecha de llegada -->
      <div class="card shadow-sm mb-3">
        <div class="card-body py-2">
          <div class="row g-2 align-items-end">
            <div class="col-md-2">
              <label class="form-label small mb-1">Fecha Llegada Desde</label>
              <input type="date" v-model="filtros.fechaInicio" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Hora Inicio</label>
              <input type="time" v-model="filtros.horaInicio" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Fecha Llegada Hasta</label>
              <input type="date" v-model="filtros.fechaFin" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Hora Fin</label>
              <input type="time" v-model="filtros.horaFin" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2 d-flex gap-1">
              <button @click="cargarReservas" class="btn btn-primary btn-sm">
                <i class="bi bi-search"></i> Buscar
              </button>
              <button @click="limpiarFiltros" class="btn btn-secondary btn-sm">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Listado -->
      <div v-if="reservas.length" class="table-responsive">
        <table class="table table-bordered">
          <thead class="table-light">
            <tr>
              <th>Código Reserva</th>
              <th>Fecha Llegada</th>
              <th>Fecha Salida</th>
              <th>Cliente</th>
              <th>Estado Reserva</th>
              <th>Estado Pago</th>
              <th>Saldo Pendiente</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="reserva in reservas" :key="reserva.IdReserva">
              <td>R00{{ reserva.IdReserva }}</td>
              <td>{{ reserva.FechaLlegada }}</td>
              <td>{{ reserva.FechaSalida }}</td>
              <td>{{ reserva.huesped.Nombre }} {{ reserva.huesped.Apellido }}</td>
              <td>
                <span
                  :class="{
                    'badge bg-warning text-dark': reserva.EstadoReserva === 0,
                    'badge bg-primary': reserva.EstadoReserva === 1,
                    'badge bg-success': reserva.EstadoReserva === 2,
                    'badge bg-danger': reserva.EstadoReserva === 3
                  }"
                >
                  {{ ['Pendiente', 'En curso', 'Finalizada', 'Cancelada'][reserva.EstadoReserva] }}
                </span>
              </td>
              <td>
                <span
                  :class="{
                    'badge bg-danger': reserva.EstadoPago === 0,
                    'badge bg-success': reserva.EstadoPago === 1
                  }"
                >
                  {{ reserva.EstadoPago === 0 ? 'Pendiente' : 'Pagado' }}
                </span>
              </td>
              <td>Q{{ parseFloat(reserva.SaldoPendiente).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="text-center text-muted fs-6 mt-4">
        No se encontraron reservas con pago pendiente.
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config'

export default {
  name: 'PendientesDePago',
  data() {
    return {
      reservas: [],
      filtros: {
        fechaInicio: '',
        horaInicio: '00:00',
        fechaFin: '',
        horaFin: '23:59',
      },
    }
  },
  methods: {
    limpiarFiltros() {
      this.filtros = {
        fechaInicio: '',
        horaInicio: '00:00',
        fechaFin: '',
        horaFin: '23:59',
      }
      this.cargarReservas()
    },
    async cargarReservas() {
      try {
        const params = {}
        if (this.filtros.fechaInicio && this.filtros.fechaFin) {
          params.fecha_inicio = this.filtros.fechaInicio
          params.hora_inicio = this.filtros.horaInicio
          params.fecha_fin = this.filtros.fechaFin
          params.hora_fin = this.filtros.horaFin
        }
        const { data } = await axios.get(`${API_URL}/reservas-pendientes-pago`, { params })
        this.reservas = data
      } catch (err) {
        console.error('Error al cargar las reservas con pago pendiente:', err)
      }
    },
    async descargarPDF() {
      if (this.reservas.length === 0) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/reservas-pendientes-pago-pdf`, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const fecha = new Date().toISOString().split('T')[0];
        link.download = `Reservas_Pendientes_Pago_${fecha}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error descargando PDF:', error);
      }
    }
  },
  mounted() {
    this.cargarReservas()
  },
}
</script>

<style scoped>
.table {
  font-size: 0.9rem;
}
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.text-danger {
  color: #dc3545;
}
.text-success {
  color: #28a745;
}
.text-warning {
  color: #ffc107;
}
</style>